import styles from "./TheTableActionBox.module.css"
const TheTableActionBox = ({children}) => {
    return(
        <div className={styles.tableActionBoxContainer}>{children}</div>
    );
}

export default TheTableActionBox;